module.exports = __webpack_public_path__ + "static/media/ski-lift.920905d9.svg";